let hours, hoursMil, minutes, ampm;
let time = [];

for (let i = 0; i <= 1410; i += 30) {
    hoursMil = hours = Math.floor(i / 60);
    if (hoursMil < 10) {
        hoursMil = '0' + hoursMil; // adding leading zero
    }

    minutes = i % 60;
    if (minutes < 10) {
        minutes = '0' + minutes; // adding leading zero
    }
    ampm = hours % 24 < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    if (hours === 0) {
        hours = 12;
    }
    time.push({
        // code: hours + ':' + minutes + ampm,
        // name: hours + ':' + minutes + ampm,
        code: hoursMil + ':' + minutes,
        name: hours + ':' + minutes + ampm,
        militaryTime: hoursMil + ':' + minutes
    });
}

export default time;



// WEBPACK FOOTER //
// ./src/helpers/times.js